import React from 'react';
import { Box } from 'rebass/styled-components';

export const TalentDivider = () => <Box sx={{ height: '0.5px', my: '40px', backgroundColor: 'border.subtle' }} />;
